import { Box } from "@chakra-ui/react"
import { useMemo } from "react"
import { sortPositionedObjects } from "../../positioning/PositioningContext"
import { useCoverPageContext } from "../CoverPageProvider"
import { ContributorCard } from "./CoverPageContributorCard"

// Immersive: Focused contributor view
const CoverPageContributorImmersive = ({ id }: { id?: number | string }) => {
  const contributors = useCoverPageContext((v) => v.contributors)
  const isMobile = useCoverPageContext((v) => v.isMobile)
  const orderedContributors = useMemo(
    () => sortPositionedObjects([...(contributors || [])]),
    [contributors]
  )

  if (!orderedContributors.length) return null

  const normalizedId = !id ? orderedContributors[0].id : Number(id)
  const contributor = orderedContributors.find(
    (author) => author.id === normalizedId
  )

  if (!contributor) return null

  return (
    <Box
      key={`contributor-${id}`}
      w="100%"
      h="100%"
      pos="relative"
      mx="auto"
      px={0}
      className="CoverPageContributorImmersive"
      bgColor="backgroundSecondary"
      borderRadius="card"
      maxHeight="100%"
      overflow="auto"
      css={{
        "& p, div, span": {
          color: "primary"
        },
        "& .ContributorCard": {
          overflow: "auto",
          p: "30px"
        },
        "& .ContributorCardContent": {
          h: "auto"
        }
      }}
    >
      <ContributorCard
        contributor={contributor}
        full={!isMobile}
        isMobile={isMobile}
        disableNavigation
        disableTruncation
      />
    </Box>
  )
}

export default CoverPageContributorImmersive
